// extracted by mini-css-extract-plugin
export default {"error":"styles-module__error___o3Knr","label":"styles-module__label____XeKi"};